module.exports = __webpack_public_path__ + "img/Dotkit-AddState.e511b158.jpg";